import React, { FC } from 'react';

// ii18n
import { useTranslation } from '../../translations/useTranslation';

// Components
import { ErrorMessage } from '../ErrorMessage';
import { Button } from '../Button';

// Interfaces
import { CgiPollingStatus } from '../../interfaces/CGI';

// Utils
import { getProviderNameFromProvider } from '../../utilities/utils';
import { useForm } from '../../context/form-context/hooks';

interface Props {
  pollingStatus: CgiPollingStatus;
  autoStartLink: string | undefined;
  pollingError?: string;
}

export const CgiSameDevice: FC<Props> = ({
  pollingStatus,
  pollingError,
  autoStartLink,
}) => {
  const { m, keys } = useTranslation();
  const { state } = useForm();

  const handleOnOpenProvider = () => {
    if (autoStartLink) {
      window.location.replace(autoStartLink);
    }
  };

  return (
    <div className="flex flex-column gap-2xs items-center">
      <p className="text-center">
        {m(
          keys.cgiDescription,
          '{provider}',
          getProviderNameFromProvider(state.provider) || ''
        )}
      </p>
      <div className="flex flex-column gap-2xs items-center">
        <div className='text-center'>
          {pollingStatus !== CgiPollingStatus.ERROR &&
            pollingStatus !== CgiPollingStatus.CANCELED && (
              <div className="flex flex-column gap-2xs items-center">
              <span className='text-sm text-italic'>
                {m(
                  keys.cgiSignInProgress,
                  '{provider}',
                  getProviderNameFromProvider(state.provider) || ''
                )}
              </span>
              </div>
            )}
          {(pollingStatus === CgiPollingStatus.ERROR ||
            pollingStatus === CgiPollingStatus.CANCELED) &&
            pollingError && (
              <p className="bg-error-high border border-error padding-y-3xs text-sm padding-x-2xs radius-sm">
                {pollingError}
              </p>
            )}
        </div>
        {pollingStatus !== CgiPollingStatus.ERROR &&
          pollingStatus !== CgiPollingStatus.CANCELED && (
            <div className="circle-loader circle-loader--v1" role="alert">
              <div aria-hidden="true">
                <div className="circle-loader__circle"></div>
              </div>
            </div>
          )}
        {autoStartLink &&
          pollingStatus !== CgiPollingStatus.ERROR &&
          pollingStatus !== CgiPollingStatus.CANCELED && (
            <div className="flex flex-column gap-2xs items-center">
              <Button
                title={m(
                  keys.uiOpenCgiApp,
                  '{provider}',
                  getProviderNameFromProvider(state.provider) || ''
                )}
                onClick={handleOnOpenProvider}
              />
            </div>
          )}
      </div>
    </div>
  );
};
